var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationCircleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5146_23893)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "translate(0.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 20C40.5 25.3043 38.3929 30.3914 34.6421 34.1421C30.8914 37.8929 25.8043 40 20.5 40C15.1957 40 10.1086 37.8929 6.35786 34.1421C2.60714 30.3914 0.5 25.3043 0.5 20C0.5 14.6957 2.60714 9.60859 6.35786 5.85786C10.1086 2.10714 15.1957 0 20.5 0C25.8043 0 30.8914 2.10714 34.6421 5.85786C38.3929 9.60859 40.5 14.6957 40.5 20ZM20.5 10C20.184 10.0002 19.8716 10.0665 19.5828 10.1948C19.294 10.3231 19.0353 10.5104 18.8234 10.7448C18.6114 10.9791 18.4509 11.2553 18.3521 11.5554C18.2534 11.8556 18.2186 12.1731 18.25 12.4875L19.125 21.255C19.1544 21.5994 19.312 21.9203 19.5666 22.1541C19.8212 22.3879 20.1543 22.5176 20.5 22.5176C20.8457 22.5176 21.1788 22.3879 21.4334 22.1541C21.688 21.9203 21.8456 21.5994 21.875 21.255L22.75 12.4875C22.7814 12.1731 22.7466 11.8556 22.6479 11.5554C22.5491 11.2553 22.3886 10.9791 22.1766 10.7448C21.9647 10.5104 21.706 10.3231 21.4172 10.1948C21.1284 10.0665 20.816 10.0002 20.5 10ZM20.505 25C19.842 25 19.2061 25.2634 18.7372 25.7322C18.2684 26.2011 18.005 26.837 18.005 27.5C18.005 28.163 18.2684 28.7989 18.7372 29.2678C19.2061 29.7366 19.842 30 20.505 30C21.168 30 21.8039 29.7366 22.2728 29.2678C22.7416 28.7989 23.005 28.163 23.005 27.5C23.005 26.837 22.7416 26.2011 22.2728 25.7322C21.8039 25.2634 21.168 25 20.505 25Z",
    fill: "#1F8DDD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5146_23893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircleFill);
export default __webpack_public_path__ + "static/media/exclamation-circle-fill.651297e53c96797b80500f66de796916.svg";
export { ForwardRef as ReactComponent };